import { render, staticRenderFns } from "./PrivilegeHistoryList.vue?vue&type=template&id=4aa32fc8&scoped=true&"
import script from "./PrivilegeHistoryList.vue?vue&type=script&lang=js&"
export * from "./PrivilegeHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeHistoryList.vue?vue&type=style&index=0&id=4aa32fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa32fc8",
  null
  
)

export default component.exports